import { UserContext } from "context/userProvider";
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "scss/screens/login/loginPage.scss";
import { Button, Form } from "semantic-ui-react";
import Swal from "sweetalert2";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const users = useContext(UserContext);
  const navigate = useNavigate();
  const usernameRegex = /^([a-zA-Z0-9])+$/;

  const alertDialog = (title, icon, text) => {
    Swal.fire({
      title: title,
      icon: icon,
      text: text,
    }).then((res) => {
      if (res.isConfirmed && icon === "success") {
        navigate("/home");
      }
    });
  };

  const onLogin = async () => {
    if (username === "" ) {
      return alertDialog("คำเตือน!", "warning", "กรุณากรอกชื่อผู้ใช้งาน");
    }
    if (password == "") {
      return alertDialog("คำเตือน!", "warning", "กรุณากรอกรหัสผ่าน")
    }
    const data = {
      id: username,
      passwd: password,
    };

    let result = await users.loginClp(data);
    if (result?.status?.result === "success") {
      return alertDialog("ล็อกอินเข้าระบบสำเร็จ!", "success", "ยินดีต้อนรับเข้าสู่ CLP KASET ADMINISTRATOR" );
    } else {
      return alertDialog("ล็อกอินเข้าระบบไม่สำเร็จ!", "warning", "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบ!");
    }
  };

  return (
    <div className="login">
      <div className="login-content">
        <div className="image">
          <img
            src={require("../../assets/CLP_LOGO.png")}
            alt="CLP logo"
            width="150"
            height="80"
          />
        </div>
        <hr />
        <h2>CLP KASET ADMINISTRATOR</h2>
        <div className="login-content-input">
          <h3>ลงชื่อเข้าใช้งาน</h3>
          <p />
          <Form>
            <Form.Field>
              <label>ชื่อผู้ใช้งาน</label>
              <input
                type="text"
                placeholder="ชื่อผู้ใช้งาน"
                value={username}
                onChange={(e) => {
                  if (e.target.value === "" ||
                    usernameRegex.test(e.target.value)
                  ) {
                    setUsername(e.target.value);
                  }
                }}
              />
            </Form.Field>
            <Form.Field>
              <label>รหัสผ่าน</label>
              <input
                type="password"
                placeholder="รหัสผ่าน"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Field>
          </Form>
          <div className="button">
            <Button color="blue" type="submit" onClick={() => onLogin()}>
              เข้าสู่ระบบ
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
